import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSortable } from '@dnd-kit/react/sortable';

const Container = styled.div`
  flex-shrink: 0;
  border-radius: 4px;
  overflow: hidden;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'grab')};
  user-select: none;
`;

export default function SortableItem({ id, index, children, disabled }) {
  const { ref } = useSortable({ id, index, disabled });

  return (
    <Container ref={ref} $disabled={disabled} data-sortable-id={id}>
      {children}
    </Container>
  );
}

SortableItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  index: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
};

SortableItem.defaultProps = {
  disabled: false,
};
